import { configureStore } from "@reduxjs/toolkit";
import cartSlice from "../Features/Cart/cartSlice";
import wishListSlice, { dedupeWishlistItems } from "../Features/Wishlist/wishListSlice";
import { getCustomerToken } from "../api/client";
import { GUEST_CART_STORAGE_KEY, WISHLIST_STORAGE_KEY } from "../utils/storageKeys";

import { readJsonStorage, writeJsonStorage } from "../utils/localStorageState";
function loadGuestCartState() {
  if (getCustomerToken()) return undefined;
  const saved = readJsonStorage(GUEST_CART_STORAGE_KEY, null);
  if (!saved || !Array.isArray(saved.items)) return undefined;
  return {
    items: saved.items,
    totalAmount: Number(saved.totalAmount) || 0,
  };
}

function loadWishlistState() {
  const saved = readJsonStorage(WISHLIST_STORAGE_KEY, null);
  if (!saved || !Array.isArray(saved.items)) return undefined;
  return { items: dedupeWishlistItems(saved.items) };
}

const loadedGuestCart = loadGuestCartState();
const loadedWishlist = loadWishlistState();

const preloadedState = {
  ...(loadedGuestCart ? { cart: loadedGuestCart } : {}),
  ...(loadedWishlist ? { wishlist: loadedWishlist } : {}),
};

const store = configureStore({
  reducer: {
    cart: cartSlice,
    wishlist: wishListSlice,
  },
  preloadedState,
});

let previousCart = store.getState().cart;
let previousWishlist = store.getState().wishlist;

store.subscribe(() => {
  const state = store.getState();
  if (state.cart !== previousCart) {
    previousCart = state.cart;
    if (!getCustomerToken()) writeJsonStorage(GUEST_CART_STORAGE_KEY, state.cart);
  }
  if (state.wishlist !== previousWishlist) {
    previousWishlist = state.wishlist;
    writeJsonStorage(WISHLIST_STORAGE_KEY, state.wishlist);
  }
});

export default store;
